import type { AdminUser } from '../firebase';
import { isSuspiciousUser } from '../suspicious';
import { toCsv } from '../csv';

const HEADERS = [
  'uid',
  'displayName',
  'email',
  'credits',
  'fullReportsCount',
  'reportsCount',
  'disabled',
  'isAdmin',
  'suspicious',
  'providerId',
  'photoURL',
  'creationTime',
  'lastSignInTime',
];

/** null → celda vacía; el resto se serializa con String(). */
function cell(value: string | number | boolean | null): string {
  if (value === null) {
    return '';
  }
  return String(value);
}

/**
 * Genera el CSV de la lista de usuarios: todos los campos de AdminUser más la
 * marca `suspicious` calculada. El orden de columnas es fijo (ver HEADERS).
 */
export function buildUsersCsv(users: AdminUser[]): string {
  const rows = users.map((u) => [
    cell(u.uid),
    cell(u.displayName),
    cell(u.email),
    cell(u.credits),
    cell(u.fullReportsCount),
    cell(u.reportsCount),
    cell(u.disabled),
    cell(u.isAdmin),
    cell(isSuspiciousUser(u)),
    cell(u.providerId),
    cell(u.photoURL),
    cell(u.creationTime),
    cell(u.lastSignInTime),
  ]);
  return toCsv(HEADERS, rows);
}
